<template>
  <div class="confirm-password d-flex justify-center">
    <div class="form-area d-flex justify-center">
      <div class="form-area__form-wrapper d-flex flex-column">
        <div class="logo flex-grow-1 d-flex align-center">
          <Img :src="getImgWithExt(['images', 'logo', 'svg'])" width="172" />
        </div>
        <div class="form-area__form flex-grow-1">
          <confirm-form-from-email v-if="$route.name == 'ConfirmPassword'" :responseResult="responseResult" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Validation from '@/mixins/Validation'
import Image from '@/mixins/Image'
import confirmFormFromEmail from '@/components/layouts/forms/confirmFormFromEmail'

export default {
  name: 'confirmPassword',
  mixins: [Validation, Image],
  components: {
    confirmFormFromEmail
  },
  data: () => ({
    form: {
      password: '',
      confirmPassword: '',
      userId: '',
      token: '',
      type: ''
    },
    responseResult: null
  }),
  async created () {
    const { id, token, type } = this.$route.params // , type
    this.form.userId = id
    this.form.token = token
    this.form.type = type
    const result = await this.passwordConfirmation({ id, token, type }) // , type
    this.responseResult = {
      userId: result.record ? result.record.id : '',
      message: result.message,
      practiceName: result.record ? result.record.practiceName : '',
      practitionerName: result.record ? result.record.practitionerName : '',
      logoFull: result.record ? result.record.logoFull : ''
    }
  },
  mounted () {
    console.log(this.$route.params)
  },
  methods: {
    ...mapActions(['passwordUpdate', 'passwordConfirmation']),
    confirm () {
      // const { id } = this.$route.params
      console.log('confirm', this.form)
      this.passwordUpdate(this.form)
    }
  },
  computed: {
    items () {
      return [
        {
          src: this.getImgWithExt(['images', 'slider', 'slide1', 'jpeg'])
        },
        {
          src: this.getImgWithExt(['images', 'slider', 'slide2', 'jpeg'])
        },
        {
          src: this.getImgWithExt(['images', 'slider', 'slide3', 'jpeg'])
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.confirm-password {
  .form-area,
  .slider-area {
    width: 50%;
    height: 100vh;
  }
  .form-area {
    background-color: #FFFFFF;
    @media (max-width: 960px) {
      width: 100%;
      padding: 0 30px;
    }
    &__form-wrapper {
      width: 439px;
    }
    &__form {
      width: 100%;
    }
  }
}
</style>
